import type { AppCopy } from '../catalogs';

export const frAppCopy = {
  welcomeHeading: "Comment puis-je vous aider aujourd'hui ?",
  thinking: 'Penser',
  scrollToBottom: 'Faire défiler vers le bas',
  reasoning: 'Raisonnement',
  reasoningInProgress: 'en cours',
  citationPages: 'Pages {first}–{last}',
  citationTitle: 'Extrait de la source',
  citationLoading: 'Chargement de la source…',
  citationUnavailable: 'Le texte cité est indisponible ou vous n’y avez plus accès.',
  citationOpen: 'Ouvrir la source',
  citationCopied: 'Référence copiée',
  copy: 'Copier',
  more: 'Plus',
  tryAgain: 'Réessayez',
  answerTruncated: 'La réponse a atteint la limite de longueur et a été coupée.',
  continueAnswer: 'Continuer la réponse',
  exportMarkdown: 'Exporter en Markdown',
  edit: 'Modifier',
  cancel: 'Annuler',
  update: 'Mise à jour',
  previous: 'Précédent',
  next: 'Suivant',
  messagePlaceholder: 'Envoyer un message…',
  projectHomePlaceholder: 'Nouvelle discussion dans {project}',
  sharedChatEveryone: 'Tout le monde chez {company} peut lire ce chat',
  sharedChatOnePerson: '1 personne peut lire ce chat',
  sharedChatPeople: '{count} personnes peuvent lire ce chat',
  forkedChatPlaceholder: 'Continuez avec vos propres connexions…',
  newAnswer: 'Nouvelle réponse',
  messageInput: 'Saisie des messages',
  sendMessage: 'Envoyer un message',
  stopGenerating: 'Arrêter de générer',
  addAttachment: 'Ajouter une pièce jointe',
  removeFile: 'Supprimer le fichier',
  attachmentPreview: 'Aperçu des pièces jointes',
  imageAttachmentPreview: 'Aperçu de la pièce jointe',
  image: 'Images',
  openLink: 'ouvrir le lien',
  document: 'Documenter',
  file: 'Fichier',
  attachment: 'pièce jointe',
  uploadFailed: 'échec du téléchargement',
  uploading: 'téléchargement',
  toolIncomplete: 'Incomplet',
  toolActivity: 'Activité',
  activityThinking: 'Réflexion…',
  activityWriting: 'Rédaction…',
  activityWaiting: 'En attente de votre approbation',
  activityStopped: 'Arrêté',
  activityCouldNotFinish: 'Impossible de terminer',
  activitySources: 'sources',
  activityShowThinking: 'Afficher la réflexion',
  activityOpen: 'Ouvrir l’activité',
  activitySteps: 'Étapes',
  activitySourcesTab: 'Sources',
  activityUnavailable: 'Cette activité est indisponible.',
  activityInput: 'Entrée',
  activityOutput: 'Sortie',
  activityNoSources: 'Cette réponse ne cite aucune source.',
  activityApprovedByReply: 'Approuvé par votre réponse',

  toolRunning: 'En cours',
  toolComplete: 'Terminé',
  toolNeedsApproval: 'Approbation requise',
  toolInput: 'Entrée',
  toolCall: "appel d'outil",
  toolCalls: "appels d'outils",
  openMenu: 'Ouvrir le menu',
  closeMenu: 'Fermer le menu',
  close: 'Fermer',
  showInTextField: 'Afficher dans le champ de texte',
  settings: 'Paramètres',
  appearance: 'Apparence',
  themeLight: 'Clair',
  themeDark: 'Sombre',
  themeSystem: 'Système',
  themeChoiceHelp:
    'S’applique sur tous vos appareils. « Système » suit le mode clair ou sombre de chaque appareil.',
  themeSaveFailed:
    'Impossible d’enregistrer l’apparence ; elle reste inchangée. Veuillez réessayer.',
  toolUsed: 'Outil utilisé',
  toolCancelled: 'Outil annulé',
  toolResult: 'Résultat :',
  toolError: 'Erreur :',
  toolCancelledReason: 'Motif annulé :',
  approvalAllow: 'Autoriser',
  approvalAlwaysAllow: 'Toujours autoriser',
  approvalDeny: 'Refuser',
  approvalAlwaysDeny: 'Toujours refuser',
  approvalConfirm: 'Confirmer',
  approvalBack: 'Retour',
  approvalApprovedResult: "Approuvé par l'utilisateur",
  approvalDeniedResult: "L'utilisateur a refusé l'exécution de l'outil",
  logout: 'Se déconnecter',
  loginOrCreateAccount: 'Se connecter / Créer un compte',
  newChat: 'Nouvelle discussion',
  untitledChat: 'Discussion sans titre',
  previousChats: 'Discussions précédentes',
  openChat: 'Ouvrir le chat {title}',
  moreActionsForChat: 'Plus de propositions pour {title}',
  chatActions: 'Actions de discussion',
  closeChatActions: 'Fermer les actions de chat',
  deleteChatQuestion: 'Supprimer le chat ?',
  deleteChatDescription: 'Le chat « {title} » sera définitivement supprimé.',
  deleteChat: 'Supprimer le chat',
  keepChat: 'Conserver le chat',
  delete: 'Supprimer',
  deleting: 'Suppression…',
  chatDeleteFailed: "Le chat n'a pas pu être supprimé. Essayer à nouveau.",
  settingsDescription: "Personnalisez la façon dont l'assistant fonctionne pour vous.",
  settingsDesktopDescription: "Personnalisez la façon dont l'assistant vous répond.",
  personalization: 'Personnalisation',
  personalizationDescription:
    "Personnalisez les instructions que l'assistant suit dans chaque réponse.",
  languageAndRegion: 'Langue et région',
  languageAndRegionDescription: 'Choisissez la langue et le fuseau horaire.',
  memories: 'Souvenirs',
  memoriesDescription: "Affichez, modifiez ou supprimez ce que l'assistant se souvient de vous.",
  account: 'Compte',
  accountDescription: 'Gérez le compte et la suppression définitive de vos données.',
  backToSettings: 'Retour aux paramètres',
  closeSettings: 'Fermer les paramètres',
  settingsCategories: 'Catégories de paramètres',
  yourSettings: 'Vos paramètres',
  dataAndAccount: 'Données et compte',
  viewAndManageMemories: "Afficher et gérer ce dont l'assistant se souvient",
  loginToUseMemories: 'Connectez-vous pour utiliser les souvenirs',
  manageOrDeleteAccount: 'Gérer ou supprimer le compte',
  unsavedChanges: 'Vous avez des modifications non enregistrées',
  unsavedCloseDescription:
    'La fermeture des paramètres annulera les modifications apportées à cette page.',
  unsavedBackDescription: 'Revenir en arrière annulera les modifications apportées à cette page.',
  continueEditing: 'Continuer la modification',
  discardChanges: 'Ignorer les modifications',
  saveChanges: 'Enregistrer les modifications',
  localSettingsNote:
    'Enregistré dans ce navigateur. Connectez-vous pour enregistrer sur votre compte.',
  personality: 'Personnalité',
  personalityHelp: "Instructions personnalisées que l'assistant suit dans chaque réponse",
  personalityPlaceholder:
    "Par exemple : Soyez concis et concret. J'habite à Göteborg et j'aime la nourriture végétarienne.",
  timezone: 'Fuseau horaire',
  searchTimezone: 'Rechercher des fuseaux horaires…',
  automaticBrowser: 'Automatique (navigateur)',
  saved: 'Enregistré : {date}',
  addMemory: 'Ajouter un souvenir',
  newMemory: 'Nouveau souvenir',
  memoryPlaceholder: 'Par exemple : Je préfère des réponses courtes et concrètes.',
  editMemory: 'Modifier le souvenir',
  saveMemory: 'Enregistrer le souvenir',
  deleteMemory: 'Supprimer le souvenir',
  memorySaveFailed: "La mémoire n'a pas pu être sauvegardée. Essayer à nouveau.",
  memoryLimitReached:
    "Vous pouvez enregistrer jusqu'à 50 souvenirs. Supprimez-en un avant d'en ajouter un autre.",
  memoryInvalid: 'Les souvenirs ne peuvent pas contenir de liens. Supprimez le lien et réessayez.',
  memoryDeleteFailed: "La mémoire n'a pas pu être supprimée. Essayer à nouveau.",
  memoryLoadFailed: "Les mémoires n'ont pas pu être chargées.",
  loadingMemories: 'Chargement des souvenirs…',
  emptyMemories:
    "L'assistant enregistre des souvenirs de vous pendant que vous parlez : ce que vous aimez, où vous vivez et ce que vous faites. Vous pouvez les afficher, les modifier et les supprimer ici.",
  deleteAccountHelp:
    'Supprimez définitivement le compte et toutes les discussions, souvenirs et paramètres associés.',
  deleteAccount: 'Supprimer le compte',
  deleteAccountQuestion: 'Supprimer définitivement le compte ?',
  deleteAccountDescription:
    'Toutes les discussions, messages, souvenirs, paramètres et informations de connexion seront supprimés. Cette action ne peut pas être annulée.',
  deleteAccountConfirm: 'Oui, supprimer mon compte',
  accountDeleteFailed: "Le compte n'a pas pu être supprimé. Rien n'a été supprimé : réessayez.",
  logoutEverywhereTitle: 'Tous les appareils',
  logoutEverywhereHelp:
    'Déconnectez-vous sur tous les appareils et navigateurs où votre compte est ouvert, y compris celui-ci.',
  logoutEverywhere: 'Se déconnecter partout',
  logoutEverywhereQuestion: 'Se déconnecter sur tous les appareils ?',
  logoutEverywhereDescription:
    'Vous devrez vous reconnecter sur tous les appareils et navigateurs, y compris celui-ci. Vos discussions et vos paramètres restent inchangés.',
  loggingOut: 'Déconnexion…',
  logoutEverywhereFailed:
    "Nous n'avons pas pu confirmer votre déconnexion de tous les appareils. Réessayez, ou vérifiez sur un autre appareil si vous êtes toujours connecté.",
  settingsSaveFailed: "Les paramètres n'ont pas pu être enregistrés. Essayer à nouveau.",
  customInstructions: 'Instructions personnalisées',
  notSet: 'Non défini',
  automaticLanguage: 'Langue automatique',
  automaticTimezone: 'fuseau horaire automatique',
  appLanguage: "Langue de l'application",
  appLanguageHelp:
    "Contrôle toute l'interface de l'application et les dates. Les réponses de l'assistant continuent de suivre la langue dans laquelle vous écrivez.",
  automaticBrowserLanguage: 'Automatique (langue du navigateur)',
  previousLanguageChoice: 'Choix précédent : {language} ({locale})',
  previousLanguageChoiceCode: 'Choix précédent ({locale})',
  canvasCopyLink: 'Copier le lien',
  canvasLinkCopied: 'Lien copié',
  actionUpdatedWithEdits: 'Mis à jour avec vos modifications',
  activityStepsDone: 'one:étape terminée|other:étapes terminées',
  activityResultsCount: 'one:résultat|other:résultats',
  canvasCopyLinkFailed: 'Impossible de copier le lien',
  canvasOpenInAgent: 'Ouvrir dans {agent}',
  canvasExpand: 'Agrandir',
  canvasExitFullView: 'Quitter la vue complète',
  webSourceUnread:
    "Lié dans cette réponse. Poneva n'a pas lu cette page, il n'y a donc rien à afficher ici.",
  webSourceOpenOriginal: "Ouvrir l'original",
  toolProgressSettings: 'Modification de vos paramètres…',
  toolProgressAgent: 'Création de l’agent…',
  toolProgressConnections: 'Recherche des options de connexion…',
  toolProgressResult: 'Préparation de votre résultat…',
  toolProgressClarification: 'Préparation d’une précision…',
  toolProgressKnowledge: 'Préparation d’une suggestion de mise à jour des connaissances…',
  toolProgressQuestion: 'Préparation d’une question pour vous…',
  toolProgressSkill: 'Élaboration de votre Skill…',
  toolErrorSettings: 'Vos paramètres n’ont pas été modifiés.',
  toolErrorAgent: 'Impossible de créer l’agent.',
  toolErrorConnections: 'Impossible de charger les options de connexion.',
  toolErrorResult: 'Le résultat n’a pas été enregistré.',
  toolErrorClarification: 'Impossible de préparer la précision.',
  toolErrorKnowledge: 'Impossible de préparer la suggestion de mise à jour des connaissances.',
  toolErrorQuestion: 'Impossible de préparer la question.',
  toolErrorSkill: 'Impossible d’enregistrer le brouillon de Skill.',
  toolErrorOpenSettings: 'Ouvrir Paramètres',
  toolErrorOpenAgents: 'Ouvrir Agents',
  toolErrorOpenConnections: 'Ouvrir Connexions',
  toolStepIncomplete: 'Cette étape n’a pas abouti.',
  toolEarlierAttemptsFailed:
    'one:tentative précédente n’a pas abouti|many:de tentatives précédentes n’ont pas abouti|other:tentatives précédentes n’ont pas abouti',
} satisfies AppCopy;
